<template>
	<div>
		<h5 class="info-text">Удали ненужные объекты или оставь как есть</h5>

		<div class="presentCard-row">                        
			<div class="col-md-6 col-lg-3 col-xl-2 presentCard" v-for="objFlat in masPresentationObjects"
			:key="objFlat.app_id">
				<!--pre>{{objFlat}}</pre-->
					<div class="btn-row btn-top mt-2">
						<div class="btn-right"><base-button type="danger" simple @click="delObj(objFlat)"><i class="tim-icons icon-trash-simple"></i></base-button></div>
					</div>

				<div class="groupTopBlock">
					<div class="groupPhoto">
						<a :href="'/data/module/sso/object/flat/'+objFlat.app_id+strDopGet" target="_blank" class="d-inline-block">
							<img v-if="objFlat.app_image != ''" :src="`/DATA/flat_files/${objFlat.gk_name_tr}/${objFlat.app_image}`" style="height: 170px;" alt=""> 
							<img v-if="objFlat.app_image == ''" src="/img/flatsDefault.svg" style="height: 170px;" alt=""> 
						</a>
					</div>
				</div>
				<div class="groupBottBlock">
						<span class="badge badge-pill badge-success mt-1">{{sold(objFlat)}}</span> 

						<div class="row justify-content-between">
							<p><b>{{objFlat.app_rooms}}</b></p>
							<p><b>ЖК &laquo;{{objFlat.gk_name}}&raquo;</b></p>
						</div>
						<p>{{$GVO.formatAmount(parseFloat(objFlat.app_flatcostwithdiscounts))}}</p>
						<p>{{objFlat.app_stotal}} м²</p>
						<p>Этаж  {{objFlat.app_flatfloor}} / {{objFlat.b_floors}}</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		masPresentationObjects: Array,
	},
  	data() {
		return {
			model: {
				firstName: '',
				lastName: '',
				email: '',
				phone: '',
				address: ''
			},
			modelValidations: {
				firstName: {
				required: true,
				min: 5
				},
				lastName: {
				required: true,
				min: 5
				},
				email: {
				required: true,
				email: true
				},
				phone: {
				required: true,
				numeric: true
				}
			}
		};
	},
	computed: {
		strDopGet: function(){
			const objGet = this.$GVO.GetAllGet();
			let strGetRet = '';
			if(typeof objGet.task_id != 'undefined' && typeof objGet.taskend_id != 'undefined' && typeof objGet.client_id != 'undefined'){
				strGetRet = `?task_id=${objGet.task_id}&taskend_id=${objGet.taskend_id}&client_id=${objGet.client_id}`;
			}
			return strGetRet;
		},
	},
	methods: {
		sold(objFlat){
			if (parseInt(objFlat.sold) == 1){
				if(parseInt(objFlat.sold) == 3){
					return 'Забронировано';
				}else{
					return 'В продаже';
				}
			}else{
				return 'Продано';
			}
		},
		delObj(objFlat){
			let objItogGetParams = this.$GVO.GetAllGet();
			this.$GVO.ApiCall('DEL_OBJ_TO_PRES',{
				obj:'presentations',
				flt:{
					task_id: objItogGetParams.task_id,
					taskend_id: objItogGetParams.taskend_id,
					client_id: objItogGetParams.client_id,
					app_id: objFlat.app_id,
					type:1,
				}
			})
			.then((objApi) => {
				if(objApi.success === true){
					if(this.masPresentationObjects.indexOf(objFlat) != -1){
						this.masPresentationObjects.splice(this.masPresentationObjects.indexOf(objFlat),1);
					}
				}
			}).catch(errorObjApi => {this.ApiData = []; console.error(errorObjApi);});
		},
		getError(fieldName) {
			return this.errors.first(fieldName);
		},
		validate() {
			return this.$validator.validateAll().then(res => {
				this.$emit('on-validated', res, this.model);
				return res;
			});
		}
	}
};
</script>
<style scoped>
.presentCard {min-width: 270px;}
.presentCard:not(:last-child) {margin-right: 15px;}
.presentCard-row, .btn-row, .btn-left, .btn-right {display: flex;}
.presentCard-row {flex-wrap: wrap;}
.btn-left, .btn-right {flex-wrap: wrap;}
.btn-left button {margin-right: 15px;}
.btn-row {justify-content: flex-end; flex-wrap: wrap;}
.btn-top .btn {padding: 10px;}
.icon-print {height: 20px; width: 20px; background-image: url('/img/icons/printer.svg'); margin: 2px 0px 0px 0px;}
.presentCard, .presentInfo-row {border: 1px solid #01b0e0; border-radius: 0.2857rem; margin-bottom: 15px;}
.groupTopBlock {border-bottom: 1px solid #01b0e0; padding: 7px 0px 20px 0px;}
.groupBottBlock {padding: 10px 0px;}
.groupPhoto {display: flex; width: 100%; height: 200px;}
.groupPhoto img {width: auto; height: 250px; margin: 0 auto; object-fit: contain; background-color: #fff!important;}
.groupBottBlock >>> button {padding: 10px 12px;}
.sendPresentation, .presentInfo-row, .flat-price, .flat-status {display: flex;}
.presentInfo-row {justify-content: space-between; flex-wrap: wrap; padding: 12px 12px 5px 12px ;}
.flat-info, .flat-checked, .send-title  {display: flex; justify-content: space-between;}
.presentInfo-row p, .flat-price, .flat-status, .flat-info p, .flat-checked {margin-right: 15px; margin-bottom: 5px;}
.sendPresentation >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01b0e0;}
.sendPresentation >>> .card-collapse {width: 100%;}
.text-crossed {text-decoration: line-through;}

/*==========send-section======================================================================*/
.send-section {padding: 15px; border: 1px solid #01b0e0; border-radius: 6px; margin-bottom: 20px;}
.send-title .btn {margin-top: -10px;}
.icon-filter{
	background-image: url('/img/icons/filter.svg');
	width:19px;
	height: 19px;
	margin-bottom: -3px;
}
.link-row, .contacts-row, .message-row {display: flex; flex-wrap: wrap;width: 100%;}
.link-input {margin-top: 4px;}
.send-form {width: 100%;}
.send-footer {display: flex; justify-content: center;}
.send-section >>> .tab-space {padding-bottom: 0px;}
.send-section >>> .card {margin-bottom: 0px;}

@media (max-width: 768px){
	.presentCard {margin-right: 0px; min-width: 100%;}
	.presentInfo-row {flex-direction: column;}
	.groupPhoto img {width: 100%; height: 100%; }
}        
@media (max-width: 575px){
	.link-input {margin-top: 10px; padding: 0px;}
	.link-row .btn {width: 100%;}
}
</style>
